import { useSelector } from 'react-redux';
import { Entities } from '../common/store/entities/entities.enum';
import { Flaggers } from '../common/store/flaggers/flaggers.enum';
import { IRootReducer } from '../common/store/root.reducer';
import { useMemo } from 'react';
import { ReducerMethods } from '../common/store/reducer.methods';
import { useDispatch } from 'react-redux';
import { FlaggersMethods } from '../common/store/flaggers/flaggers.methods';

interface UseEntity<T> {
  entityData: T;
  getEntityById: (id: string) => T | undefined;
  setEntityData: (data: T, type?: ReducerMethods | FlaggersMethods) => void;
}

interface UseEntityProps {
  entityType: Entities | Flaggers,
  entityId?: string
}

export const useEntity = <T>({
  entityType,
  entityId
}: UseEntityProps): UseEntity<T> => {
  const dispatch = useDispatch();
  const entityDataFromStore = useSelector((state: IRootReducer) => state[entityType]);

  const getEntityById = (id: string): T | undefined => {
    return entityDataFromStore?.[id];
  }

  const entityData = useMemo(() => {
    return entityId !== undefined && entityId !== null ? getEntityById(entityId) : entityDataFromStore;
  }, [entityId, entityDataFromStore]);

  const setEntityData = (data: T, type: ReducerMethods | FlaggersMethods = ReducerMethods.UPDATE) => {
    const entityData = entityId ? { [entityId]: data } : data;
    dispatch({
      type,
      payload: { entities: { [entityType]: entityData } },
    });
  }

  return { entityData, getEntityById, setEntityData };
};
